/* @ngInject */
function RecentsController ($scope, $state, $location, $stateParams, RepositoryService) {
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  const api = {
  }

  this.getApi = () => api

  function activate () {
    const view = RepositoryService.getView()
    if (view) {
      $location.search({ view })
    } else if ($stateParams.view) {
      $location.search({ view: $stateParams.view })
      RepositoryService.setView($stateParams.view)
    }
  }

  activate()
}

export { RecentsController }
